import { useCallback } from "react";

import { useTypedQuery } from "hooks";
import { TyreGroupQueryKeys } from "modules/AppointmentDetails/components/VehicleTyres/queryKeys";
import { ApiInstance } from "utils/Api";

import type { Tyre, VehicleTyreReplacement } from "models";

const selectTyreTeamStock = (tyre_replacements: VehicleTyreReplacement[], stockTyres: Tyre[]) => {
  const stockTyresWithId: Tyre[] = [];

  stockTyres.forEach(st => {
    const replacement = tyre_replacements.find(tr => tr.tyre?.ean === st.ean);

    if (replacement?.tyre) {
      st.id = replacement.tyre.id;
      stockTyresWithId.push(st);
    }
  });

  return stockTyresWithId;
};

export const useTyreTeamStock = (isTyreTeamEnabled: boolean, tyre_replacements: VehicleTyreReplacement[]) => {
  const query = useTypedQuery({
    queryKey: TyreGroupQueryKeys.tyreTeamStock(tyre_replacements.map(tr => tr.id)),
    queryFn: async ({ baseUrl, endpoint, params }) => (tyre_replacements.length > 0 ? (await ApiInstance.post(endpoint, params, baseUrl)).data.tyres : []),
    enabled: isTyreTeamEnabled,
    select: useCallback((stockTyres: Tyre[]) => selectTyreTeamStock(tyre_replacements, stockTyres), [tyre_replacements])
  });

  return {
    data: query.data,
    isFetching: query.isFetching
  };
};
